import { createContext } from "react";

let ThemeContext = createContext();

export default ThemeContext;
